import { Paper, TableContainer } from '@material-ui/core'
import { KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons'
import LastPageIcon from '@mui/icons-material/LastPage'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import PropTypes from 'prop-types'
import { useTheme } from '@mui/material/styles'
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
  Pagination,
  Button
} from '@mui/material'
import { useEffect, useState } from 'react'
import { CSVLink } from 'react-csv'
import GetAppIcon from '@material-ui/icons/GetApp'
import moment from 'moment'

function TablePaginationActions(props) {
  const theme = useTheme()
  const { count, page, rowsPerPage, onPageChange } = props
  const [previousCount, setPreviousCount] = useState(count)

  useEffect(() => {
    if (count !== previousCount && page !== 0) {
      onPageChange(null, 0)
    }
    setPreviousCount(count)
  }, [count, page, onPageChange, previousCount])

  const handleFirstPageButtonClick = event => {
    onPageChange(event, 0)
  }

  const handleBackButtonClick = event => {
    onPageChange(event, page - 1)
  }

  const handleNextButtonClick = event => {
    onPageChange(event, page + 1)
  }

  const handleLastPageButtonClick = event => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
  }

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label='first page'
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label='previous page'
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label='next page'
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label='last page'
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  )
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired
}
export default function NewDynamicTable({ data }) {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data.length) : 0

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }
  const columnNames = data.reduce((columns, row) => {
    Object.keys(row).forEach(column => {
      if (!columns.includes(column)) {
        columns.push(column)
      }
    });
    return columns;
  }, []);
  return <TableContainer component={Paper}>
    <Table>
      <TableHead>
        <TableRow>
          {((rowsPerPage > 0 ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : data) && (rowsPerPage > 0 ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : data).length > 0 ? Object.keys((rowsPerPage > 0 ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : data)[0] || {}) : []).map((key, index) => <TableCell key={index} sx={{
            textAlign: 'left'
          }}><b>{key}</b></TableCell>)}
        </TableRow>
      </TableHead>
      <TableBody>
        {((rowsPerPage > 0 ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : data) || []).map((row, rowIndex) => <TableRow key={rowIndex}>
          {Object.entries(row || {}).map(([key, val], valIndex) => {
            let displayVal = val;
            if (typeof val === 'number' && !Number.isInteger(val)) {
              displayVal = val.toFixed(2);
            } else if (typeof val === 'string' && !isNaN(val) && val.trim() !== '' && val.includes('.')) {
              displayVal = parseFloat(val).toFixed(2);
            } else if (typeof val === 'boolean') {
              displayVal = val ? 'Yes' : 'No';
            } else if (val === null || val === undefined) {
              displayVal = '';
            } else if (typeof val === 'object') {
              displayVal = JSON.stringify(val);
            }
            return <TableCell key={valIndex} sx={{
              textAlign: 'left'
            }}>
              {String(displayVal)}
            </TableCell>;
          })}
        </TableRow>)}
      </TableBody>
    </Table>
  </TableContainer>;
}